<template>
  <div>
    <custom-email
      :company="company"
      :kv-pending="kvPending"
      :category="category"
      :created="created"
      :active="isActive"
      @update="update"
    />
  </div>
</template>

<script>
import CustomEmail from './custom-email/custom-email.vue';

export default {
  components: {
    CustomEmail,
  },
  props: {
    kvTemplates: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      created: false,
      kvPending: null,
      categoryName: null,
      isActive: false,
    };
  },
  mounted() {
    this.categoryName = { 1: 'assignment', 2: 'pending', 3: 'expiration', 4: 'answered' };
    this.isActive = this.kvPending?.state === 'active';
  },
  beforeMount() {
    this.kvPending = this.kvTemplates.find(t => t.category === 'pending');
    if (this.kvPending) this.created = true;
  },
  methods: {
    update() {
      this.$emit('update');
    },
  },
};
</script>

<style>

</style>
